import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, obj=logged in
  const token = () => localStorage.getItem("ba_admin_token");

  const check = useCallback(async () => {
    if (!token()) return setUser(false);
    try {
      const { data } = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      setUser(data);
    } catch {
      localStorage.removeItem("ba_admin_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("ba_admin_token", data.token);
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem("ba_admin_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, token }}>
      {children}
    </AuthContext.Provider>
  );
}
